import { Flex, Button } from "antd"
import { Text } from "ui/Typography"
import { systemPrompts } from "../constants"
import { spacings } from "themes/variables"
import { useTranslation } from "react-i18next"
import { useAssistantPersona } from "hooks/useAssistantPersona"
import classNames from "classnames"
import styles from "../ChatBox.module.css"
import PropTypes from "prop-types"

const SystemPrompt = ({ handlePromptClick, selectedPrompt, showGreeting = true }) => {
  const { t } = useTranslation()
  const persona = useAssistantPersona()
  const name = t(persona.nameKey)
  const greeting = t(persona.greetingKey, { name, productName: t(persona.productNameKey) })

  return (
    <Flex vertical gap={spacings.M}>
      {showGreeting && (
        <Flex align="start" gap={spacings.S}>
          <Text className={classNames(styles.aiMessage, styles.greetingMessage)}>{greeting}</Text>
        </Flex>
      )}
      <Flex justify="center" gap={spacings.XS} wrap>
        {systemPrompts.map((prompt) => {
          const title = t(prompt.titleKey)
          return (
            <Button
              key={prompt.id}
              className="py-xs px-l"
              variant="outlined"
              color="primary"
              disabled={!!selectedPrompt}
              type={selectedPrompt === title ? "primary" : "default"}
              onClick={() => handlePromptClick(title)}
            >
              {title}
            </Button>
          )
        })}
      </Flex>
    </Flex>
  )
}

SystemPrompt.propTypes = {
  handlePromptClick: PropTypes.func.isRequired,
  selectedPrompt: PropTypes.string,
  showGreeting: PropTypes.bool
}

export default SystemPrompt
